'use client';

import { EXPOSURE_RECORD } from '@/tracks/32521';
// -------------- components -------------------- //
import SidebarAccordion from './SidebarAccordion';
import styles from './SidebarAccordion.module.scss';

interface SidebarPropType {
  sidebarData: Array<any>;
  selected: number;
  setSelected: (val: number) => void;
  handleFetch: (val: string) => void;
}

const BestSellerSideBar = ({
  sidebarData,
  selected,
  setSelected,
  handleFetch,
}: SidebarPropType) => {
  return (
    sidebarData &&
    sidebarData.map((items: any, index: number) => {
      return (
        <div
          key={items?.categoryTabName.toString() + index}
          exptag={'exp|' + EXPOSURE_RECORD.Activity_BestSellersHome_Tab_Expo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          data-exptag-json-param={JSON.stringify({
            tabName: (sidebarData && sidebarData?.map((item: any) => item.categoryTabName)) || [
              '-100',
            ],
          })}
          className={styles.sidebarAccordionContainer}
        >
          <SidebarAccordion
            key={items?.categoryTabName.toString() + index}
            title={items?.categoryTabName}
            index={index}
            level={items?.level}
            selected={selected}
            setSelected={setSelected}
            isFirst={index === 0}
            data={items}
            handleFetch={handleFetch}
          />
        </div>
      );
    })
  );
};

export default BestSellerSideBar;
